/** מנרמל snoozeEndTime מהשרת (DB) ל-ISO string לתצוגה */
export function normalizeSnoozeEndTimeFromApi(raw: unknown): string | null {
  if (raw == null) return null;

  if (typeof raw === 'string') {
    const trimmed = raw.trim();
    if (!trimmed) return null;
    const parsed = Date.parse(trimmed);
    if (Number.isNaN(parsed)) return null;
    return new Date(parsed).toISOString();
  }

  if (typeof raw === 'number' && Number.isFinite(raw)) {
    return new Date(raw).toISOString();
  }

  return null;
}

/** קורא snoozeEndTime מאובייקט lastSession / תשובת session (camel + Pascal) */
export function snoozeEndTimeFromSessionRecord(session: unknown): string | null {
  if (!session || typeof session !== 'object') return null;
  const s = session as Record<string, unknown>;
  const raw =
    s.snoozeEndTime ??
    s.SnoozeEndTime ??
    s.snoozeEndDate ??
    s.SnoozeEndDate ??
    null;
  return normalizeSnoozeEndTimeFromApi(raw);
}

export function isSnoozeTimePassed(iso: string | null | undefined): boolean {
  if (!iso) return false;
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return false;
  return Date.now() >= t;
}

export function isValidFutureSnoozeIso(iso: string | null | undefined): boolean {
  if (!iso) return false;
  const t = Date.parse(iso);
  return !Number.isNaN(t) && !isSnoozeTimePassed(iso);
}
